/* import __COLOCATED_TEMPLATE__ from './basic-modal.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
/**
  Component for displaying generic information in market. Based on deprecated modal-layout
  example of use:
    <Modals::GenericModalMarket
      @title={{t-i18n "inventory2.vendor.unsavedChangesModal.title"}}
      @modalType="destructive"
      @primaryButton={{t-i18n "inventory2.vendor.unsavedChangesModal.discard"}}
      @secondaryAction={{action "warningModalCancel"}}
      @primaryAction={{action "warningModalConfirm"}}
    >
      <p>Text content of modal</p>
    </Modals::GenericModalMarket>
    @param {String} [title] Modal title
    @param {String} [modalType] modal variant
    @param {String} [primaryButton] primary button label
    @param {Action} [primaryAction] primary button action
    @param {Boolean} [primaryButtonDisabled] set true to disable primary button
    @param {String} [secondaryButton] close button label
    @param {Action} [secondaryAction] close button action
    @param {Boolean} [showSecondaryButton] whether the close button is shown or not
    @param {Action} [tertiaryAction] tertiary button action
    @param {String} [tertiaryButton] tertiary button label
    @param {Boolean} [disableCloseButton] whether the close button is disabled or not
  */

import Component from '@glimmer/component';
import { action } from '@ember/object';
export const BASIC_MODAL_VARIATIONS = {
  DESTRUCTIVE: 'destructive',
  REGULAR: 'regular'
};
let BasicModal = (_class = class BasicModal extends Component {
  onPrimaryAction() {
    this.args.primaryAction();
  }
  onSecondaryAction() {
    this.args.secondaryAction();
  }
  onTertiaryAction() {
    this.args.tertiaryAction();
  }
}, _applyDecoratedDescriptor(_class.prototype, "onPrimaryAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onPrimaryAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSecondaryAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSecondaryAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onTertiaryAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onTertiaryAction"), _class.prototype), _class);
export { BasicModal as default };